import { RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const BIG = "min-h-14 h-auto py-3 px-5 text-lg rounded-xl justify-start text-left whitespace-normal break-words";

export function ResetButton({ onClick, t }) {
  return (
    <Button variant="outline" className="h-12 px-4 text-base" onClick={onClick} data-testid="reset-form-btn">
      <RotateCcw className="w-5 h-5 mr-2" />{t("Start over")}
    </Button>
  );
}

export function ResetDialog({ open, setOpen, docName, multi, onReset, t }) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="font-kiosk max-w-lg" data-testid="reset-dialog">
        <DialogHeader>
          <DialogTitle className="text-2xl">{t("Start over?")}</DialogTitle>
          <DialogDescription className="text-lg">{t("reset_body")}</DialogDescription>
        </DialogHeader>
        <div className="grid gap-3">
          {docName && <Button variant="outline" className={BIG} onClick={() => onReset("document")} data-testid="reset-current-btn">
            <RotateCcw className="w-5 h-5 mr-3" />{t("Clear this form")}: {docName}</Button>}
          {multi && <Button variant="outline" className={`${BIG} text-red-700`} onClick={() => onReset("packet")} data-testid="reset-all-btn">
            <RotateCcw className="w-5 h-5 mr-3" />{t("Start all forms over")}</Button>}
          <Button className="h-14 text-lg rounded-xl bg-[#0B3D8C] hover:bg-[#082F6B]" onClick={() => setOpen(false)} data-testid="reset-cancel-btn">{t("Keep my answers")}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
